import { makeAutoObservable } from 'mobx';
import SmartPolicy from './SmartPolicy';
export default class SmartPolicies {
    constructor(serverData) {
        Object.defineProperty(this, "policies", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        makeAutoObservable(this);
        serverData.forEach((policyData) => {
            const policy = new SmartPolicy(policyData);
            this.policies[policy.rootId] = policy;
        });
    }
}
